export const LIST_BULLET_TYPE = {
	Numbers: "numbers",
	Checkmarks: "checkmarks",
	Custom: "custom",
	Image: "image",
	Icon: "icon",
};
